import React, { useState } from "react";

import "../../../../style/create-new-app-env.module.css";
import "../../../../style/select-service-type.module.css";
import saasAnalytics from "../../../../dashboard/saas/saasAnalytics";
import { PaidFeaturesModalSteps } from "../EnablePaidFeaturesModal";

type SelectServiceProps = {
    onCloseModal: () => void;
    setCurrentPaidFeaturesModalStep: (step: PaidFeaturesModalSteps) => void;
};

export default function SelectServiceType({ onCloseModal, setCurrentPaidFeaturesModalStep }: SelectServiceProps) {
    return (
        <div className="modal-container max-content">
            <div className="modal-header">
                <h2>Enable / Disable Paid Features</h2>
                <span
                    className="close-btn"
                    onClick={() => {
                        saasAnalytics.enablePaidFeaturesModalClose("choose-a-service");
                        onCloseModal();
                    }}
                >
                    <img src="static/assets/dashboard/close-rounded.png" />
                </span>
            </div>
            <div className="modal-body">
                <div className="services-container">
                    <Service setCurrentPaidFeaturesModalStep={setCurrentPaidFeaturesModalStep} type="self_hosted" />
                    <Service setCurrentPaidFeaturesModalStep={setCurrentPaidFeaturesModalStep} type="managed" />
                </div>
            </div>
        </div>
    );
}

type ServiceProps = {
    type: "managed" | "self_hosted";
    setCurrentPaidFeaturesModalStep: (step: PaidFeaturesModalSteps) => void;
};

const supertokensServicesConfig = {
    managed: {
        title: "Managed Service"
    },
    self_hosted: {
        title: "Self hosted"
    }
};

function Service({ type, setCurrentPaidFeaturesModalStep }: ServiceProps) {
    const [isHovered, setIsHoverd] = useState(false);

    function getRightArrowUrl() {
        if (isHovered) {
            return "/static/assets/dashboard/orange-right-arrow.svg";
        }
        return "/static/assets/dashboard/black-right-arrow.svg";
    }

    function getServiceImage() {
        if (type === "managed") {
            if (isHovered === true) {
                return "/static/assets/dashboard/managed-service-active.svg";
            } else {
                return "/static/assets/dashboard/managed-service.svg";
            }
        } else {
            if (isHovered === true) {
                return "/static/assets/dashboard/self-hosted-active.svg";
            } else {
                return "/static/assets/dashboard/self-hosted.svg";
            }
        }
    }

    function handleServiceSelection() {
        saasAnalytics.enablePaidFeaturesSelectedType(type);

        if (type === "managed") {
            setCurrentPaidFeaturesModalStep("generate-licensekey-for-managed-service");
        }

        if (type === "self_hosted") {
            setCurrentPaidFeaturesModalStep("generate-licensekey-for-self-hosted");
        }
    }

    return (
        <div
            className="service-container"
            onMouseEnter={() => setIsHoverd(true)}
            onMouseLeave={() => setIsHoverd(false)}
            onClick={handleServiceSelection}
        >
            <div className="left-box">
                <img src={getServiceImage()} alt={supertokensServicesConfig[type].title} />
                <h3>{supertokensServicesConfig[type].title}</h3>
            </div>
            <div className="right-box">
                <img src={getRightArrowUrl()} alt="right-arrow" />
            </div>
        </div>
    );
}
